import {
  API_PATH,
  BASE_BACKEND_PROD_URL,
  BASE_BACKEND_STAGE_URL,
} from "../constants/UrlsConstants";

export const getBaseUrl = () => {
  const env = process.env.REACT_APP_NODE_ENV;
  console.log(env);
  if (env === "PROD") {
    return BASE_BACKEND_PROD_URL;
  } else if (env === "STAGE") {
    return BASE_BACKEND_STAGE_URL;
  } else {
    return BASE_BACKEND_STAGE_URL;
  }
};

export const getApiUrl = () => {
  return `${getBaseUrl()}${API_PATH}`;
};

export const makeUrl = (path) => {
  const url = getApiUrl() + path;
  return url;
};
